export const newsCategories = ["全部", "新闻报道", "专题分析", "影评", "行业动态"];

export const newsList = [
  {
    id: "n01",
    title: "旧影院最后一夜：新宿单厅放映的告别与延续",
    category: "新闻报道",
    date: "2024-12-06",
    author: "本刊编辑部",
    excerpt:
      "东京新宿一间只有一百二十个座位的单厅影院在十二月初结束营业。最后一夜放映的是一部十六毫米胶片旧作，散场后观众留在座位上聊了将近一小时。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20single%20screen%20cinema%20interior%20with%20red%20velvet%20seats%20and%20dim%20warm%20light%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n01&orientation=landscape",
    tags: ["单厅影院", "新宿", "胶片"],
    sections: [
      {
        text: "十二月的第一个周五，新宿三丁目那间开了四十七年的单厅影院放完了最后一场。售票窗口在开场前十分钟关闭，工作人员把剩下的纸质票根整齐地摆在柜台上，作为告别。",
      },
      {
        text: "最后一夜放映的是一部一九八〇年代的十六毫米作品，拷贝来自片方的私人收藏。放映机中途卡带两次，观众没有抱怨，反而在黑暗中笑出声来。",
        image:
          "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%2016mm%20film%20projector%20in%20a%20dusty%20booth%20with%20light%20beam%2C%20warm%20tones%2C%20film%20grain%2C%20no%20text&width=1000&height=600&seq=jpf-n01-b1&orientation=landscape",
        caption: "放映室里的十六毫米放映机，最后一次运转",
      },
      {
        text: "影院经营者表示，场地将在明年春天改造成小型展演空间，仍会保留部分座椅与银幕。「电影不一定每天放，但这个房间不该被清空。」他在散场后这样说。",
      },
      {
        text: "值得注意的是，近三年东京都内已有四间单厅影院结束营业，其中两间转为多功能空间。业者普遍认为，规模小、片单垂直的影院反而更容易维持固定观众，但租金仍是最大压力。",
      },
    ],
  },
  {
    id: "n02",
    title: "从纸门到霓虹：日本成人文艺电影的摄影脉络",
    category: "专题分析",
    date: "2024-11-22",
    author: "影评人 · 高濑 圭",
    excerpt:
      "六十年来，这类影片的摄影语言经历了从自然光室内调度，到霓虹夜景，再到数字低照度三段变化。每一次技术更替，都改变了「观看距离」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20comparison%20mood%2C%20soft%20light%20through%20shoji%20screen%20next%20to%20a%20neon%20lit%20night%20window%2C%20warm%20and%20cold%20contrast%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n02&orientation=landscape",
    tags: ["摄影", "灯光", "技术史"],
    sections: [
      {
        text: "如果要用一句话概括这六十年的变化，大概是：摄影机离人物越来越近，但观众离人物越来越远。",
      },
      {
        text: "八十年代的作品依赖纸门与自然光。光线经过一层和纸之后变得极软，人物轮廓被削弱，画面因此带有一种克制的距离感。摄影师必须精确计算一天中光线的角度，拍摄窗口往往只有两小时。",
        image:
          "https://readdy.ai/api/search-image?query=Soft%20diffused%20light%20through%20a%20paper%20shoji%20screen%20in%20an%20empty%20tatami%20room%2C%20warm%20neutral%20tones%2C%20no%20text&width=1000&height=600&seq=jpf-n02-b1&orientation=landscape",
        caption: "和纸过滤后的自然光，是八十年代作品的基础语言",
      },
      {
        text: "九十年代后期，城市夜景成为主流。钠灯与霓虹提供了高对比的色温混合，画面变得更「脏」，也更诚实。这一时期的摄影师开始大量使用反射与玻璃，让人物先以倒影出现。",
      },
      {
        text: "数字摄影普及之后，低照度不再是限制。如今的剧组可以在几乎没有光的环境里拍摄，画面干净得近乎临床。代价是颗粒感的消失——那种属于胶片的、不完美的呼吸。也正因如此，近五年有相当数量的导演重新回到十六毫米。",
      },
    ],
  },
  {
    id: "n03",
    title: "《雨后》影评：一场没有落地的对话",
    category: "影评",
    date: "2024-11-08",
    author: "影评人 · 森下 千鹤",
    excerpt:
      "小林澪的新作把全部时间压缩进一个下午。它几乎是今年最安静的电影，也是最不肯放过观众的一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20rainy%20Kyoto%20stone%20alley%20at%20dusk%20with%20wet%20reflections%20and%20warm%20lantern%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n03&orientation=landscape",
    tags: ["雨后", "小林澪", "梅雨"],
    sections: [
      {
        text: "《雨后》有一个非常危险的设定：两个人从午后走到黄昏，一直在说话，却始终没有说出最重要的一句。这种「延宕」如果处理不好，会变成两小时的折磨。小林澪的处理方式是让摄影机保持礼貌的距离。",
      },
      {
        text: "全片最出色的调度发生在旧书店的檐下。雨停之后，屋檐仍在滴水，两人并排站着，谁也没有先动。导演把这场戏剪了整整两分四十秒，没有一个反打镜头。观众被迫与两人一起等待。",
        image:
          "https://readdy.ai/api/search-image?query=Rain%20dripping%20from%20a%20wooden%20eaves%20in%20a%20Kyoto%20old%20street%2C%20close%20up%20with%20soft%20focus%2C%20film%20grain%2C%20no%20text&width=1000&height=600&seq=jpf-n03-b1&orientation=landscape",
        caption: "檐下的一场戏，全片情绪的支点",
      },
      {
        text: "值得讨论的是结尾。放晴之后，路面蒸起薄雾，其中一人转身走进巷子。这里没有任何音乐，只有远处的电车声。这个处理让影片避开了廉价的感伤，也让「没有结果」本身成为结果。",
      },
      {
        text: "如果一定要挑毛病，中段关于旧书店的支线略显多余。但这不影响它成为今年最值得在雨天独自观看的作品。",
      },
    ],
  },
  {
    id: "n04",
    title: "十六毫米复兴：年轻导演为什么重新选择胶片",
    category: "行业动态",
    date: "2024-10-25",
    author: "本刊编辑部",
    excerpt:
      "过去两年，日本独立电影中使用十六毫米胶片的项目数量明显上升。成本更高、流程更慢，但导演们说，他们需要的正是这种「不方便」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%2016mm%20film%20cans%20and%20a%20hand%20winding%20a%20reel%20in%20a%20workshop%2C%20warm%20light%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n04&orientation=landscape",
    tags: ["胶片", "独立电影", "制作"],
    sections: [
      {
        text: "在东京的一家冲洗工作室里，负责人说过去一年接到的十六毫米冲洗委托比三年前多了将近一倍。「大部分是三十岁上下的导演，拍短片，也有长片。」",
      },
      {
        text: "选择胶片的理由并不浪漫。受访的几位导演都提到「限制」：一卷只能拍两分半，不能无限重来，因此必须在开拍前想清楚。这种限制让现场的工作方式发生改变，演员也更专注。",
        image:
          "https://readdy.ai/api/search-image?query=Hand%20holding%20a%20strip%20of%20film%20against%20a%20light%20box%2C%20close%20up%2C%20warm%20dark%20room%2C%20no%20text&width=1000&height=600&seq=jpf-n04-b1&orientation=landscape",
        caption: "冲洗与校色仍是最耗时的环节",
      },
      {
        text: "成本依然是门槛。十六毫米的胶片与冲洗费用，大约是同长度数字拍摄的三到四倍。多数项目依靠小型基金与影院预购支持。",
      },
      {
        text: "不过，发行端对胶片的兴趣也在回升。部分单厅影院开始安排「胶片限定场」，上座率往往高于同期数字场次。对观众来说，划痕与抖动不再是缺陷，而是一种在场证明。",
      },
    ],
  },
  {
    id: "n05",
    title: "《红房间的记忆》重看：重复作为一种叙事方法",
    category: "影评",
    date: "2024-10-11",
    author: "影评人 · 高濑 圭",
    excerpt:
      "五年之后重看佐野川透的这部作品，会发现它的结构比当年评论所说的更精密。重复并非停滞，而是逐层剥落。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20dim%20room%20with%20deep%20crimson%20wall%20and%20single%20warm%20lamp%2C%20heavy%20shadow%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n05&orientation=landscape",
    tags: ["红房间的记忆", "佐野川透", "重看"],
    sections: [
      {
        text: "第一次看《红房间的记忆》，最直接的感受是「慢」。五年后再看，慢的部分依然慢，但能看出每一次重复都在削减一个细节。",
      },
      {
        text: "第一段里，房间里有一台唱机、一面镜子、一扇窗。到了第三段，镜子被布盖住了。这个变化没有任何台词提示，观众只能在画面边缘注意到。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20mirror%20covered%20with%20cloth%20in%20a%20dark%20room%2C%20warm%20edge%20light%2C%20film%20grain%2C%20no%20text&width=1000&height=600&seq=jpf-n05-b1&orientation=landscape",
        caption: "被盖住的镜子，是影片最安静的一次转折",
      },
      {
        text: "结尾窗帘被风掀起，日光第一次进入房间。这个镜头常被解读为「释怀」，但我更愿意把它看作一种清空：房间终于不再需要承载记忆了。",
      },
    ],
  },
  {
    id: "n06",
    title: "地方城市取景热：小影院与老街区的互相成全",
    category: "新闻报道",
    date: "2024-09-27",
    author: "特约记者 · 藤原 沙耶",
    excerpt:
      "金泽、鸟取、福冈等地近期出现多部以本地街区为主要场景的作品。地方影院与取景地之间，正在形成一种新的合作关系。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20small%20local%20cinema%20facade%20on%20a%20quiet%20Japanese%20street%20at%20dusk%2C%20warm%20light%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n06&orientation=landscape",
    tags: ["地方影院", "取景地", "金泽"],
    sections: [
      {
        text: "在金泽，一间只有八十个座位的影院今年安排了四次本地取景作品的特映。放映结束后，导演与当地居民一起在门口聊到深夜。",
      },
      {
        text: "这种模式对双方都有好处。剧组获得低廉的场地与真实的街区质感，影院则得到独家放映档期与稳定客流。部分地方政府也开始提供小额取景补助。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20narrow%20old%20town%20street%20with%20wooden%20houses%20and%20paper%20lanterns%20at%20evening%2C%20film%20grain%2C%20no%20text&width=1000&height=600&seq=jpf-n06-b1&orientation=landscape",
        caption: "老街区提供的真实质感，是布景难以复制的",
      },
      {
        text: "不过也有隐忧。居民反映，拍摄期间的交通管制与灯光扰民时有发生。业内人士建议，建立更清晰的沟通机制，比单纯增加补助更重要。",
      },
    ],
  },
  {
    id: "n07",
    title: "声音的叙事：为什么这类电影比想象中更依赖环境音",
    category: "专题分析",
    date: "2024-09-13",
    author: "声音设计 · 大庭 亮",
    excerpt:
      "在画面被刻意压暗、压缩的作品里，声音往往承担了更多信息。水管、电车、蝉鸣，都是叙事的一部分。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20field%20recorder%20and%20headphones%20on%20a%20dark%20table%2C%20warm%20lamp%20light%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n07&orientation=landscape",
    tags: ["声音设计", "环境音", "后期"],
    sections: [
      {
        text: "很多观众以为这类影片的听觉重点是音乐。实际上，大部分作品几乎没有配乐，声音设计的工作量集中在对白之外的层。",
      },
      {
        text: "以《月之背面》为例，整部片子的空间感几乎完全由楼梯间的回声建立。同一句台词，在一楼与顶楼录制的混响完全不同。声音团队为此在实景中搭建了临时录音点。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20microphone%20on%20a%20stand%20in%20an%20empty%20stairwell%20with%20dim%20light%2C%20no%20text&width=1000&height=600&seq=jpf-n07-b1&orientation=landscape",
        caption: "实景录音决定了影片的空间可信度",
      },
      {
        text: "另一个常被忽略的细节是静默。真正的安静在影院里几乎不可能实现，因此团队会用极低音量的环境底噪填充，让观众感受到「房间还在呼吸」。",
      },
    ],
  },
  {
    id: "n08",
    title: "修复版的意义：老片重映不只是提高分辨率",
    category: "行业动态",
    date: "2024-08-30",
    author: "本刊编辑部",
    excerpt:
      "近两年多部旧作推出修复版。修复团队强调，最难的部分不是去划痕，而是判断「应该保留多少不完美」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20film%20restoration%20workstation%20with%20old%20frames%20on%20screen%2C%20dark%20room%20with%20warm%20desk%20lamp%2C%20no%20text&width=1200&height=800&seq=jpf-n08&orientation=landscape",
    tags: ["修复", "重映", "胶片"],
    sections: [
      {
        text: "一部旧作的修复通常需要三到六个月。流程包括清洁、扫描、稳定、去闪、调色与声音重建，每一步都要在「还原」与「过度处理」之间做判断。",
      },
      {
        text: "最容易引发争议的是调色。原片在当年放映时受放映机灯泡色温影响，观众看到的颜色与底片本身并不一致。修复团队必须决定：还原底片，还是还原当年的观影经验。",
        image:
          "https://readdy.ai/api/search-image?query=Close%20up%20of%20color%20grading%20control%20panel%20in%20a%20dark%20suite%2C%20warm%20and%20cold%20indicator%20lights%2C%20no%20text&width=1000&height=600&seq=jpf-n08-b1&orientation=landscape",
        caption: "调色是修复中最需要判断力的环节",
      },
      {
        text: "多数团队选择折中：以底片为准，同时保留轻微的颗粒与闪烁。完全干净的画面反而会让观众觉得陌生。",
      },
    ],
  },
  {
    id: "n09",
    title: "《静默的火焰》影评：一口灶台上的二十年",
    category: "影评",
    date: "2024-08-16",
    author: "影评人 · 森下 千鹤",
    excerpt:
      "早川佳奈第一次拍家庭关系，就把所有冲突关进了一间厨房。蒸汽、油声与刀工，替人物说完了所有难说的话。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20small%20Japanese%20diner%20kitchen%20with%20steam%20and%20warm%20hanging%20lamp%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=jpf-n09&orientation=landscape",
    tags: ["静默的火焰", "早川佳奈", "家庭"],
    sections: [
      {
        text: "厨房是一个很适合拍家庭的空间：狭窄、有明火、必须协作。早川佳奈把它当作舞台，摄影机固定在出餐口的位置，观众与客人一起看进去。",
      },
      {
        text: "母女之间的每一次争执都发生在备菜过程中，谁也没有停下手里的活。这个设定让情绪始终被动作牵制，不会滑向煽情。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20hands%20chopping%20vegetables%20on%20a%20worn%20wooden%20cutting%20board%2C%20warm%20light%2C%20no%20text&width=1000&height=600&seq=jpf-n09-b1&orientation=landscape",
        caption: "所有难说的话，都被刀工盖过去了",
      },
      {
        text: "拆迁那天，母亲照常营业到夜里十一点。这个结尾没有给任何解释，却是整部影片最有力量的地方：生活不会因为一个通知而暂停。",
      },
    ],
  },
];